<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item label="类别编码" prop="categoryCode">-->
<!--                <a-input v-model="queryParam.categoryCode" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'类别编码'" allow-clear @pressEnter="handleQuery"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item label="类别名称" prop="categoryName">
                <a-input v-model="queryParam.categoryName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'类别名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template>
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="单位配置" prop="unitOptions">-->
<!--                  <a-input v-model="queryParam.unitOptions" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'次,小时,天,单'" allow-clear @pressEnter="handleQuery"/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="6" :sm="24">
                <a-form-item label="支持预约" prop="supportAppointment">
                  <a-select v-model="queryParam.supportAppointment" :placeholder="$t('通用.输入.请选择')+'支持预约'" allow-clear @change="handleQuery">
                    <a-select-option :value="1">是</a-select-option>
                    <a-select-option :value="0">否</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="创建时间" prop="createdAt">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.createdAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item label="更新时间" prop="updatedAt">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.updatedAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item :label="$t('通用.文本.创建开始时间')" prop="createBeginTime">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"-->
<!--                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"-->
<!--                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item :label="$t('通用.文本.创建结束时间')" prop="createEndTime">-->
<!--                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"-->
<!--                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"-->
<!--                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="12" :sm="12">
              <span class="table-page-search-submitButtons" :style=" { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
              </a-col>
            </template>

          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['task:taskcategoryconfig:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['task:taskcategoryconfig:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['task:taskcategoryconfig:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['task:taskcategoryconfig:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createdAt" slot-scope="text, record">
          {{ parseTime(record.createdAt) }}
        </span>
        <span slot="updatedAt" slot-scope="text, record">
          {{ parseTime(record.updatedAt) }}
        </span>
        <span slot="supportAppointment" slot-scope="text, record">
          {{ record.supportAppointment === 1 ? '是' : record.supportAppointment === 0 ? '否' : '-' }}
        </span>
        <span slot="status" slot-scope="text, record">
          {{ record.status === 1 ? '启用' : record.status === 0 ? '禁用' : '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['task:taskcategoryconfig:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['task:taskcategoryconfig:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['task:taskcategoryconfig:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['task:taskcategoryconfig:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTaskCategoryConfig,listTaskCategoryConfig, delTaskCategoryConfig } from '@/api/task/taskCategoryConfig'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'TaskCategoryConfig',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        categoryCode: undefined,
        categoryName: undefined,
        taskType: undefined,
        identityTagOptions: undefined,
        unitOptions: undefined,
        supportAppointment: undefined,
        sortNo: undefined,
        status: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '主键ID',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '类别编码',
        //   dataIndex: 'categoryCode',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '类别名称',
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务类型',
          dataIndex: 'taskType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '身份标签配置，逗号分隔，如:男,女,本科,舞蹈老师,KTV,驾龄3年',
          dataIndex: 'identityTagOptions',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '单位配置，逗号分隔，如:次,小时,天,单',
          dataIndex: 'unitOptions',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支持预约',
          dataIndex: 'supportAppointment',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'supportAppointment' }
        },
        {
          title: '排序值',
          dataIndex: 'sortNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createdAt',
          scopedSlots: { customRender: 'createdAt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updatedAt',
          scopedSlots: { customRender: 'updatedAt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询任务类别配置列表 */
    getList () {
      this.loading = true
     pageTaskCategoryConfig(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        categoryCode: undefined,
        categoryName: undefined,
        taskType: undefined,
        identityTagOptions: undefined,
        unitOptions: undefined,
        supportAppointment: undefined,
        sortNo: undefined,
        status: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          return delTaskCategoryConfig(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('task/task/category/config/export',
            that.queryParam
          , `任务类别配置_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
